export const CONTACT = {
  company: "MAXIMUS RUBBER INDUSTRIES PVT LTD",
  brand: "MAXIMUS TREADS",
  tagline: "High Performance Precured Tread Rubber",
  addressLines: [
    "Industrial Growth Centre, Rubber Park",
    "P.O. R.K. Nagar, Khayerpur, West Tripura",
  ],
  note: "Under the Technical Guidance of the Rubber Board, Govt. of India",
  phones: ["9612899617"],
  email: "support@maximustreads.in",
};

export const DISTRIBUTOR = {
  name: "M/S Royal Tyres & Tread",
  location: "Rajbari, Dharmanagar, North Tripura",
  phone: "7005249823",
  gst: "16AILPD7780P1ZJ",
  authorized: "Authorized Distributor of Maximus Rubber Industries Pvt. Ltd.",
};

export const USPS = [
  { key: "life", label: "Longer Tyre Life" },
  { key: "cost", label: "Cost Efficient" },
  { key: "mileage", label: "Better Mileage" },
  { key: "sustain", label: "Sustainable Choice" },
];

const U = (id, params = "q=80&w=2000&auto=format&fit=crop") =>
  `https://images.unsplash.com/${id}?${params}`;

export const IMAGES = {
  hero: U("photo-1636725380807-f68194d1aa3c"),
  tread1: U("photo-1596512667203-a23e7b5c8df0", "q=80&w=1600&auto=format&fit=crop"),
  tread2: U("photo-1644671253203-90cab345211c", "q=80&w=1600&auto=format&fit=crop"),
  factory1: U("photo-1646082276009-bb35409086ed"),
  factory2: U("photo-1598299803204-b73796f43289"),
  fleet1: U("photo-1586191552066-d52dd1e3af86"),
  fleet2: U("photo-1591419478162-a4dd21b7ec0a"),
  stacked:
    "https://images.pexels.com/photos/29348624/pexels-photo-29348624.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CATEGORIES = [
  {
    id: "tread",
    label: "Precured Tread Rubber",
    desc: "The MAX range — all types of radial & bias precured tread rubber, engineered for high mileage.",
    count: "15 patterns",
  },
  {
    id: "bonding",
    label: "Bonding Gum",
    desc: "Cold process bonding gum that locks every MAXIMUS tread to a prepared casing.",
    count: "On request",
  },
  {
    id: "solution",
    label: "Vulcanising Solution",
    desc: "Cold process vulcanising solution for a dependable, even cure.",
    count: "On request",
  },
  {
    id: "process",
    label: "Cold Process",
    desc: "Our product focus — retreading built around the cold process system, tread to solution.",
    count: "System",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Compound Integrity",
    copy: "We use the best raw materials in the market along with high technology — the foundation of every strip of MAXIMUS precured tread rubber.",
  },
  {
    no: "02",
    title: "Precision Manufacturing",
    copy: "Our Tripura plant is equipped with the latest Kneader, Extruder, Calendaring Machine, Mixing Mill and Curing Press.",
  },
  {
    no: "03",
    title: "Quality At Every Stage",
    copy: "We initiate quality checks at each and every stage of production — starting from mixing, extrusion and curing. Nothing ships unchecked.",
  },
  {
    no: "04",
    title: "High Mileage, Delivered",
    copy: "By providing the best performance precured tread rubber, we help our customers achieve high mileage — radial and bias, every type.",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];
